import { useState } from "react";
import { toast } from "sonner";
import { ChevronDown, Scale, Undo2 } from "lucide-react";
import { Money } from "./SaudiRiyal";
import { api } from "../lib/api";

const AR_M = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
const mLabel = (k) => `${AR_M[Number(k.slice(5, 7)) - 1]} ${k.slice(0, 4)}`;
const Diff = ({ v }) => <span className={`font-bold ${v > 0 ? "text-rose-600" : v < 0 ? "text-emerald-600" : "text-slate-400"}`}>{v > 0 ? "+" : v < 0 ? "−" : ""}<Money value={Math.abs(v)} /></span>;

const Batch = ({ b, canEdit, onUndo }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-lg bg-slate-50 px-3 py-2 text-xs" data-testid={`renewal-batch-${b.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        <button onClick={() => setOpen(!open)} className="flex items-center gap-1 font-semibold text-slate-700"><ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />{b.paid_date} · {b.count} مقيم · {b.months === 12 ? "سنة" : `${b.months} أشهر`}</button>
        <span className="text-slate-500">محسوب <Money value={b.calculated} /> · مدفوع <Money value={b.paid} /></span>
        <Diff v={b.diff} />
        {canEdit && <button onClick={() => onUndo(b)} className="ms-auto flex items-center gap-1 text-rose-600 hover:underline" data-testid={`renewal-undo-${b.id}`}><Undo2 className="h-3 w-3" /> تراجع</button>}
      </div>
      {open && <div className="mt-1.5 space-y-0.5 text-slate-600">{b.employees.map((e) => <p key={e.id}>{e.name} <span dir="ltr" className="font-mono-nums text-slate-400">{e.old_expiry || "—"} → {e.new_expiry}</span></p>)}
        {b.note && <p className="text-slate-500">ملاحظة: {b.note}</p>}<p className="text-slate-400">بواسطة {b.by}</p></div>}
    </div>
  );
};

export const RenewalCompare = ({ data, canEdit, onChanged }) => {
  if (!data?.months?.length) return null;
  const undo = async (b) => {
    if (!window.confirm(`التراجع عن تجديد ${b.count} مقيم بتاريخ ${b.paid_date}؟ ترجع تواريخ الإقامات كما كانت.`)) return;
    try { await api.undoIqamaRenewal(b.id); toast.success("تم التراجع"); onChanged(); } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر التراجع"); }
  };
  return (
    <div className="space-y-2 rounded-xl border border-slate-200 p-3" data-testid="renewal-compare">
      <p className="flex items-center gap-1.5 text-sm font-semibold text-slate-700"><Scale className="h-4 w-4 text-indigo-600" /> المحسوب مقابل المدفوع فعلياً</p>
      <div className="overflow-x-auto"><table className="w-full text-xs">
        <thead><tr className="text-slate-500"><th className="py-1 text-start">الشهر</th><th>الإقامات</th><th>المحسوب</th><th>المدفوع</th><th>الفرق</th></tr></thead>
        <tbody>{data.months.map((m) => (
          <tr key={m.month} className="border-t border-slate-100 text-center" data-testid={`renewal-month-${m.month}`}>
            <td className="py-1.5 text-start font-semibold">{mLabel(m.month)}</td><td>{m.count}</td><td><Money value={m.calculated} /></td><td><Money value={m.paid} /></td><td><Diff v={m.diff} /></td>
          </tr>))}</tbody>
      </table></div>
      <div className="space-y-1.5">{data.batches.slice(0, 20).map((b) => <Batch key={b.id} b={b} canEdit={canEdit} onUndo={undo} />)}</div>
    </div>
  );
};
